import React, { FC } from "react";
import { ThemeName } from "@evergis/ui";

import { Header, HeaderContainer, HeaderFrontView, HeaderIcon, IconHeaderWrapper } from "../styled";
import { FeatureCardControls } from "../components/FeatureCardHeader/FeatureCardControls";
import { FeatureCardButtons } from "../components/FeatureCardHeader/FeatureCardButtons";
import { FeatureCardIcon } from "../components/FeatureCardHeader/FeatureCardIcon";
import { FeatureCardTitle } from "../components/FeatureCardHeader/FeatureCardTitle";
import { ThemeProvider } from "../../../components/ThemeProvider";
import { ContainerProps } from "../types";

export const IconHeader: FC<ContainerProps> = ({ config, isRow, renderElement }) => {
  return (
    <IconHeaderWrapper
      $fontColor={config?.options?.fontColor}
      $bgColor={config?.options?.bgColor}
      $bigIcon={config?.options?.bigIcon}
    >
      <ThemeProvider themeName={ThemeName.Light}>
        <Header $isRow={isRow}>
          <HeaderFrontView>
            <HeaderContainer>
              <FeatureCardIcon image={renderElement({ id: "image", wrap: false })} />
              <FeatureCardTitle
                title={renderElement({ id: "title", wrap: false })}
                description={renderElement({ id: "description", wrap: false })}
              />
            </HeaderContainer>
            <FeatureCardButtons />
          </HeaderFrontView>
          <HeaderIcon>{renderElement({ id: "icon", wrap: false })}</HeaderIcon>
        </Header>
      </ThemeProvider>
      <FeatureCardControls />
    </IconHeaderWrapper>
  );
};
